module.exports = __webpack_public_path__ + "img/nomads_grid.ec1579df.svg";